$(function() {
    const countdown = {
        init() {
            countdown.create();
        },
        create() {

            $('[data-countdown]').each(function(index, el) {
                var $this = $(this);
                var currentTime = new Date().getTime();
                var eventTime = $this.data('countdown');

                var distance = eventTime - currentTime;

                var days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
                var seconds = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');


                $this.find(".w-days").text(days);
                $this.find(".w-hours").text(hours);
                $this.find(".w-mins").text(minutes);
                $this.find(".w-seconds").text(seconds);

                if (distance <= 0) {
                    $this.find(".w-days").text("00");
                    $this.find(".w-hours").text("00");
                    $this.find(".w-mins").text("00");
                    $this.find(".w-seconds").text("00");
                } else {

                    var intervalId = setInterval(function() {
                        if (distance <= 0) {
                            clearInterval(intervalId);
                            $this.find(".w-days").text("00");
                            $this.find(".w-hours").text("00");
                            $this.find(".w-mins").text("00");
                            $this.find(".w-seconds").text("00");
                        }

                        currentTime = new Date().getTime();
                        distance = eventTime - currentTime;
                        days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
                        hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
                        minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
                        seconds = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');
                        
                        $this.find(".w-days").text(days);
                        $this.find(".w-hours").text(hours);
                        $this.find(".w-mins").text(minutes);
                        $this.find(".w-seconds").text(seconds);
                    }, 1000);
                }
            })
        }
    };

    countdown.init();
});